export default __webpack_public_path__ + "static/media/audioMessage.722f450c.svg";